import {FC, useState, createContext, useContext, useEffect} from 'react'
import {WithChildren} from '../.././../../../_metronic/helpers'
import {QueryRequestContextProps, QueryState, initialQueryRequest} from './_init'
import {useListView} from './ListViewProvider'
import {stringifyRequestQuery} from '../.././../../../_metronic/helpers'

const QueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

const QueryRequestProvider: FC<WithChildren> = ({children}) => {
  const {typeProduct} = useListView()
  const [state, setState] = useState<QueryState>(initialQueryRequest.state)

  const updateState = (updates: Partial<QueryState>) => {
    const updatedState = {...state, ...updates} as QueryState
    setState(updatedState)
  }

  useEffect(() => {
  }, [state])

  return (
    <QueryRequestContext.Provider value={{state, updateState}}>
      {children}
    </QueryRequestContext.Provider>
  )
}

const useQueryRequest = () => useContext(QueryRequestContext)
export {QueryRequestProvider, useQueryRequest}
